import { useQuery } from "@tanstack/react-query";
import Table from "../../ChildComponents/Table";
import { MdEditDocument } from "react-icons/md";

import { useGetPage } from "../../store/api/pageApi";

function RoleList({ onEdit }) {
  const getPage = useGetPage();
  const {
    data: pageData,
    isLoading: isPageLoading,
    error: pageError,
  } = useQuery({ queryKey: "pages", queryFn: getPage });

  const data = pageData?.data
    ?.map((e, index) => ({
      index: index + 1,
      title: e?.title,
      actionButton: (
        <>
          <button onClick={() => onEdit(e)} className="btn text-success mx-2">
            <MdEditDocument />
          </button>
        </>
      ),
    }))
    .reverse();

  const columns = [
    {
      header: "SL#",
      accessor: "index",
    },
    {
      header: "Title",
      accessor: "title",
    },
    {
      header: "Actions",
      accessor: "actionButton",
    },
  ];
  return (
    <div>
      <Table columns={columns} data={data} isLoading={isPageLoading} />
    </div>
  );
}

export default RoleList;
